import {
  ACTIVEID,
  USER_LOGGED_IN_DETAILS,
  ADMIN_SIDEBAR_SCROLL_POSITION,
  ADMIN_ACTIVE_SIDEBAR_MENU
} from "../types";

const initialState = {
  userDetails: {},
  activeID: "",
  scrollPositionAdmin: 0,
  adminActiveSidebarTab: 1,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGGED_IN_DETAILS: {
      return {
        ...state,
        userDetails: action.payload,
      };
    }
    case ACTIVEID: {
      return {
        ...state,
        activeID: action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
